import userDefaultImage from '../assets/images/ic_default_user.png'

export const useImage = () => {
    const renderThumbnail = src => {
        if (src?.trim() && src !== 'empty') {
            return `${src}?type=webp&width=500&quality=100`
        } else {
            return userDefaultImage
        }
    }

    const renderImage = (src, width?: number) => {
        if (src?.trim() && src !== 'empty') {
            return `${src}?type=webp&width=${width ? (width < 200 ? 200 : width) : 1920}&quality=100`
        } else {
            return ''
        }
    }

    return {renderThumbnail, renderImage}
}
